import { render, staticRenderFns } from "./TouchButton.vue?vue&type=template&id=aa754800&scoped=true"
import script from "./TouchButton.vue?vue&type=script&lang=js"
export * from "./TouchButton.vue?vue&type=script&lang=js"
import style0 from "./TouchButton.vue?vue&type=style&index=0&id=aa754800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa754800",
  null
  
)

export default component.exports